'use client';

import React from 'react';

import LessonCategoryCard from '@/components/design/lessonCategoryCard';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { Skeleton } from '@/components/ui/skeleton';
import useLessonCategories from '@/hooks/queries/useLessonCategories';
import { cn } from '@/lib/utils';
import routes from '@/statics/routes';

type Props = {
  className?: string;
};

const LandingLessensCarousel: React.FC<Props> = () => {
  const { data, isFetched } = useLessonCategories();

  if (isFetched && !data) {
    return null;
  }

  const categories = data || [null, null, null, null];

  return (
    <Carousel
      opts={{
        align: 'start',
        direction: 'rtl',
        loop: false,
        dragFree: true,
      }}
    >
      <CarouselContent>
        {categories.map((category, index) => (
          <CarouselItem
            className={cn(
              'flex-[0_0_30%]',
              index === 0 && 'ms-5',
              index === categories.length - 1 && 'me-5'
            )}
            key={category ? category.id : index}
          >
            {category === null ? (
              <Skeleton key={index} className="w-full rounded-xl" />
            ) : (
              <LessonCategoryCard
                content={category}
                link={`${routes.lessons.url}?category_id=${category.id}`}
              />
            )}
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default LandingLessensCarousel;
